import { c as _c } from "react/compiler-runtime";
import { useTranslation } from 'react-i18next';
import { SectionHeadline } from '@/components/SectionHeadline';
import React, { useMemo } from 'react';
import { StackCards } from '@/components/StackCards';
import { NumericRange } from '@/types/range';
import { Card } from '@/components/StackCards/types';
import { Button } from '@/components/buttons';
export function Cards(t0) {
  const $ = _c(13);
  const {
    onCtaClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["cssProgram"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  let t2;
  if ($[1] !== onCtaClick || $[2] !== t) {
    t2 = Array.from({
      length: 5
    }, (_, index) => {
      const cardIndex = index + 1 as NumericRange<1, 5>;
      return {
        index,
        title: <div className="text-center lg:text-left">{t(`cards.${cardIndex}.title`)}</div>,
        footer: cardIndex === 1 ? <Button analyticsParam="cssProgramCardsContact" testId="cssProgramCardsContact" variant="primary" size="lg" className="m-auto w-full md:w-auto lg:m-0" onClick={onCtaClick}>{t(`cards.${cardIndex}.button`)}</Button> : cardIndex === 5 ? <Button analyticsParam="cssProgramCardsWantIt" testId="cssProgramCardsWantIt" variant="primary" size="lg" className="m-auto w-full md:w-auto lg:m-0" onClick={onCtaClick}>{t(`cards.${cardIndex}.button`)}</Button> : undefined,
        images: {
          desktop: {
            src: `/images/sections/cssProgram/cards/cs/${cardIndex}.png`,
            alt: t(`cards.${cardIndex}.title`)
          },
          mobile: {
            src: `/images/sections/cssProgram/cards/cs/${cardIndex}.png`,
            alt: t(`cards.${cardIndex}.title`)
          }
        }
      };
    });
    $[1] = onCtaClick;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const cards = t2;
  let t3;
  if ($[4] !== t) {
    t3 = t("cards.title");
    $[4] = t;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <SectionHeadline className="mt-14 mb-12 px-4 lg:mt-20 lg:mb-16" anchorKey="cards.title">{t3}</SectionHeadline>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== cards) {
    t5 = <StackCards imagePosition="left" cards={cards} />;
    $[8] = cards;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}